import { useEffect, useState } from 'react';
import api from './api';

/**
 * Fetch the combined version manifest: GET /api/version ->
 *   { processor: {version,url,sha256,notes} | null, recorder: {...} | null }
 * Returns { data, loading, error }.
 */
export default function useVersions() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    api
      .get('/version')
      .then((res) => alive && setData(res.data))
      .catch(() => alive && setError(true))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  return { data, loading, error };
}
